import { Select, MenuItem, Typography } from "@mui/material";
import i18n from "../../utils/i18n";
import { useSetLocale, useGetLocale, useInvalidate } from "@refinedev/core";
import { setAxiosLanguage } from "../../utils/axios";

export const LanguageSelect = ({
  compact = false,
  disablePortal = false,
}: {
  compact?: boolean;
  disablePortal?: boolean;
}) => {
  const changeLanguage = useSetLocale();
  const locale = useGetLocale();
  const currentLocale = locale();
  const invalidate = useInvalidate();

  const handleChangeLanguage = (lang: string) => {
    setAxiosLanguage(lang);
    changeLanguage(lang);
    invalidate({
      resource: "all",
      invalidates: ["all"],
    });
  };

  return (
    <Select
      size="small"
      value={currentLocale ?? " "}
      onChange={(e) => handleChangeLanguage(e.target.value)}
      variant="outlined"
      sx={{ minWidth: compact ? 70 : 100 }}
      MenuProps={disablePortal ? { disablePortal: true } : undefined}
    >
      {[...(i18n.languages ?? [])].map((lang: string) => (
        <MenuItem selected={currentLocale === lang} key={lang} value={lang}>
          <Typography color="text.secondary">
            {compact
              ? lang.toUpperCase()
              : lang === "en"
                ? "English"
                : "Türkçe"}
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
};
